@if (!touchDevice()) {
    <div>
        <div (cdkDropListDropped)="drop($event, libraryChapters())" [cdkDropListDisabled]="!editMode" cdkDropList class="tree">
            @for (chapter of libraryChapters(); track chapter.id) {
                <div cdkDrag>
                    <div (click)="chapter['expanded'] = !chapter['expanded']" cdkDragHandle class="title">
                        <button [disabled]="chapter.sub_items.length < 1" mat-icon-button>
                            @if (chapter.sub_items.length > 0) {
                                <mat-icon class="mat-icon-rtl-mirror fas {{chapter['expanded'] ? 'fa-chevron-down' : 'fa-chevron-right'}}"></mat-icon>
                            } @else if (chapter.sub_items.length < 1) {
                                <mat-icon class="mat-icon-rtl-mirror fas fa-folder-open"></mat-icon>
                            }
                        </button>
                        {{chapter.name}}
                        @if (editMode) {
                            <button (click)="renameItem($event, chapter)" mat-icon-button>
                                <mat-icon class="fas fa-pencil-alt"></mat-icon>
                            </button>
                            <button (click)="addNewItem($event, chapter, true)" mat-icon-button>
                                <mat-icon class="fas fa-plus"></mat-icon>
                            </button>
                            <button (click)="deleteItem($event, chapter)" color="primary" mat-icon-button>
                                <mat-icon class="fas fa-trash"></mat-icon>
                            </button>
                        }
                    </div>
                    <div (cdkDropListDropped)="drop($event, chapter.sub_items)" [cdkDropListDisabled]="!editMode" cdkDropList>
                        @for (subChapter of chapter.sub_items; track subChapter) {
                            <div [class.expanded]="chapter['expanded']" cdkDrag class="tree-content">
                                @if (!subChapter.file) {
                                    <div cdkDragHandle class="title">
                                        <button (click)="subChapter['expanded'] = !subChapter['expanded']" [disabled]="subChapter.sub_items.length <1" mat-icon-button>
                                            @if (subChapter.sub_items.length > 0) {
                                                <mat-icon class="mat-icon-rtl-mirror fas {{subChapter['expanded'] ? 'fa-chevron-down' : 'fa-chevron-right'}}"></mat-icon>
                                            } @else if (subChapter.sub_items.length < 1) {
                                                <mat-icon class="mat-icon-rtl-mirror fas fa-folder-open"></mat-icon>
                                            }
                                        </button>
                                        <div (click)="subChapter['expanded'] = !subChapter['expanded']">{{subChapter.name}}</div>
                                        @if (editMode) {
                                            <button (click)="renameItem($event, subChapter)" mat-icon-button>
                                                <mat-icon class="fas fa-pencil-alt"></mat-icon>
                                            </button>
                                            <button (click)="addNewItem($event, subChapter)" mat-icon-button>
                                                <mat-icon class="fas fa-upload"></mat-icon>
                                            </button>
                                            <button (click)="deleteItem($event, subChapter, chapter)" color="primary" mat-icon-button>
                                                <mat-icon class="fas fa-trash"></mat-icon>
                                            </button>
                                        }
                                    </div>
                                }
                                @if (subChapter.file) {
                                    <div class="document">
                                        <button (click)="download(subChapter.id)" color="primary" mat-button>
                                            <i class="far fa-file-pdf pe-2"></i>{{subChapter.name}}
                                        </button>
                                        @if (editMode) {
                                            <button (click)="deleteItem($event, subChapter, chapter)" color="primary" mat-icon-button>
                                                <mat-icon class="fas fa-trash"></mat-icon>
                                            </button>
                                        }
                                    </div>
                                }
                                <div (cdkDropListDropped)="drop($event, subChapter.sub_items)" [cdkDropListDisabled]="!editMode" cdkDropList>
                                    @for (subSubChapter of subChapter.sub_items; track subSubChapter) {
                                        <div [class.expanded]="subChapter['expanded']" cdkDrag class="tree-content">
                                            <div cdkDragHandle class="document">
                                                <button (click)="download(subSubChapter.id)" color="primary" mat-button>
                                                    <i class="far fa-file-pdf pe-2"></i>{{subSubChapter.name}}
                                                </button>
                                                @if (editMode) {
                                                    <button (click)="renameItem($event, subSubChapter)" mat-icon-button>
                                                        <mat-icon class="fas fa-pencil-alt"></mat-icon>
                                                    </button>
                                                    <button (click)="deleteItem($event, subSubChapter, subChapter)" color="primary" mat-icon-button>
                                                        <mat-icon class="fas fa-trash"></mat-icon>
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
        @if (editMode) {
            <button (click)="addNewItem($event, group)" color="primary" mat-raised-button>
                Hoofdstuk toevoegen
            </button>
        }
    </div>
} @else {
    <div>
        <div class="tree">
            @for (chapter of libraryChapters(); track chapter) {
                <div>
                    <div (click)="chapter['expanded'] = !chapter['expanded']" class="title">
                        <button [disabled]="chapter.sub_items.length <1" mat-icon-button>
                            @if (chapter.sub_items.length > 0) {
                                <mat-icon class="mat-icon-rtl-mirror fas {{chapter['expanded'] ? 'fa-chevron-down' : 'fa-chevron-right'}}"></mat-icon>
                            } @else if (chapter.sub_items.length < 1) {
                                <mat-icon class="mat-icon-rtl-mirror fas fa-folder-open"></mat-icon>
                            }
                        </button>
                        {{chapter.name}}
                    </div>
                    <div>
                        @for (subChapter of chapter.sub_items; track subChapter) {
                            <div [class.expanded]="chapter['expanded']" class="tree-content">
                                @if (!subChapter.file) {
                                    <div class="title">
                                        <button
                                            (click)="subChapter['expanded'] = !subChapter['expanded']"
                                            [disabled]="subChapter.sub_items.length <1"
                                            mat-icon-button>
                                            @if (subChapter.sub_items.length > 0) {
                                                <mat-icon class="mat-icon-rtl-mirror fas {{subChapter['expanded'] ? 'fa-chevron-down' : 'fa-chevron-right'}}"></mat-icon>
                                            } @else if (subChapter.sub_items.length < 1) {
                                                <mat-icon class="mat-icon-rtl-mirror fas fa-folder-open"></mat-icon>
                                            }
                                        </button>
                                        <div (click)="subChapter['expanded'] = !subChapter['expanded']">{{subChapter.name}}</div>
                                    </div>
                                }
                                @if (subChapter.file) {
                                    <div class="document">
                                        <button (click)="download(subChapter.id)" color="primary" mat-button>
                                            <i class="far fa-file-pdf pe-2"></i>{{subChapter.name}}
                                        </button>
                                    </div>
                                }
                                <div>
                                    @for (subSubChapter of subChapter.sub_items; track subSubChapter) {
                                        <div [class.expanded]="subChapter['expanded']" class="tree-content">
                                            <div class="document">
                                                <button (click)="download(subSubChapter.id)" color="primary" mat-button>
                                                    <i class="far fa-file-pdf pe-2"></i>{{subSubChapter.name}}
                                                </button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
}
